import { finishedProjects } from "@/data/galleryProjectsData";

/** Finished projects gallery grid */
export function ProjectGalleryGrid() {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Completed <span className="text-gradient-gold">Projects</span>
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Finished masonry, paving, and outdoor living projects from across Bergen, Essex, Morris, and Passaic Counties in North New Jersey.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {finishedProjects.map((project, index) => (
            <div
              key={index}
              itemScope
              itemType="https://schema.org/ImageObject"
              className="group relative overflow-hidden rounded-xl aspect-square bg-muted"
            >
              <img
                src={project.image}
                alt={project.alt}
                loading="lazy"
                itemProp="contentUrl"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <meta itemProp="name" content={project.title} />
              <div itemProp="contentLocation" itemScope itemType="https://schema.org/Place">
                <meta itemProp="name" content={project.location} />
                <div itemProp="geo" itemScope itemType="https://schema.org/GeoCoordinates">
                  <meta itemProp="latitude" content={String(project.lat)} />
                  <meta itemProp="longitude" content={String(project.lng)} />
                </div>
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-sm font-semibold text-foreground">{project.title}</p>
                <p className="text-xs text-secondary">{project.location}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
